import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';
import tippy from 'tippy.js';
import style from 'tippy.js/dist/tippy.css';
import { log } from 'util';

Snappy.Component.Tooltip = class Tooltip extends Snappy.BaseComponent {
    static get tagName() {
        return 'tooltip';
    }

    constructor(element) {
        super(element);
        this.element = element;
    }

    render() {
        this.setVars();
        this.initTooltip();
    }

    setVars() {
        this.customOptions = {};
        try {
            const optionsString = this.element.getAttribute('data-tooltip-options');
            if (optionsString) {
                this.customOptions = JSON.parse(optionsString);
            }

        } catch (e) {
            console.log(e);
        }

        this.options = Object.assign({}, Tooltip.defaultOptions, this.customOptions);
        this.options.html = this.element.querySelector('[data-tooltip-content]');

    }


    initTooltip() {
        console.log(this.options);
        this.tooltip = tippy(this.element, this.options);
    }

    static get defaultOptions() {
        return {
            delay: 100,
            arrow: true,
            arrowType: 'sharp',
            size: 'small',
            duration: 250,
            animation: 'shift-toward',
            maxWidth: '250px',
            placement: 'right',
            interactive: 'true'
        }
    }
};



// WEBPACK FOOTER //
// ./components/tooltip/scripts/tooltip.js